export default "__VITE_ASSET__UObZzEVA__"